import { render, staticRenderFns } from "./Media_back.vue?vue&type=template&id=67e16f46&"
import script from "./Media_back.vue?vue&type=script&lang=js&"
export * from "./Media_back.vue?vue&type=script&lang=js&"
import style0 from "./Media_back.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports